/***优惠券***/
<template>
  <div class="coupon">
    <xk-coupon-nav :data="navDataFn"></xk-coupon-nav>
    <div class="couponContent">
      <router-view></router-view>
    </div>
    {{v5zcCoupon}}
  </div>
</template>

<script>
  import XkCouponNav from '../../module/couponNav/src/couponNav'
  import {mapGetters} from 'vuex'

  export default {
    components: {
      XkCouponNav
    },
    name: '',
    computed: {
      ...mapGetters({
        // usedCoupons: 'usedCoupons',
        // unusedCoupons: 'unusedCoupons',
        // expireCoupons: 'expireCoupons',
        // v5ZcCouponsGetter: 'v5ZcCouponsGetter'
        allCouponsGetter: 'allCouponsGetter'
      }),
      navDataFn: function () {
        let that = this
        return [
          {
            name: '未使用',
            num: that.unusedCoupons ? that.unusedCoupons.length : 0,
            router: '/coupon/nused'
          },
          {
            name: '使用记录',
            num: that.usedCoupons ? that.usedCoupons.length : 0,
            router: '/coupon/used'
          },
          {
            name: '已失效',
            num: that.expireCoupons ? that.expireCoupons.length : 0,
            router: '/coupon/stale'
          }
        ]
      },
      v5zcCoupon () {
        let that = this
        let allCoupons = this.allCouponsGetter ? this.allCouponsGetter : []
        if (allCoupons && allCoupons.length > 0) {
          allCoupons.forEach(function (index, row) {
            console.log(index, row)
            if (row.state === 1) {
              that.unusedCoupons.push(row)
            } else if (row.state === 2) {
              that.usedCoupons.push(row)
            } else if (row.state === 3) {
              that.expireCoupons.push(row)
            }
          })
        }
      }
    },
    data () {
      return {
        unusedCoupons: [],
        usedCoupons: [],
        expireCoupons: []
      }
    },
    mounted: function () {
      console.log('v5ZcCouponsGetter', this.v5ZcCouponsGetter)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .coupon {
    width: 100vw;
    height: 100vh;
    box-sizing: border-box;
    overflow: hidden;
    background-color: #f3f4f5;
    .couponContent {
      box-sizing: border-box;
      height: 100%;
      width: 100%;
      padding-top: 3.6rem;
      .loadMoreBut {
        width: 100%;
        line-height: 3rem;
        padding-bottom: 1rem;
        span {
          width: 100%;
          line-height: 3rem;
          color: #666;
          background-color: #fff;
          border-radius: 0.333rem;
          text-align: center;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// coupon.vue?54265848